import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  id: "show-flows",
  class: "d-flex flex-fill list-page"
}
const _hoisted_2 = ["id"]
const _hoisted_3 = {
  key: 0,
  class: "warning-div"
}
const _hoisted_4 = { class: "warning-text" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = {
  key: 1,
  class: "warning-div"
}
const _hoisted_7 = { class: "warning-text" }
const _hoisted_8 = ["id"]
const _hoisted_9 = ["id"]
const _hoisted_10 = ["id", "onClick"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = ["id"]
const _hoisted_13 = ["id", "src", "alt"]
const _hoisted_14 = { class: "d-flex flex-row justify-content-between" }
const _hoisted_15 = { class: "col" }
const _hoisted_16 = { class: "d-flex align-items-center" }
const _hoisted_17 = { class: "btn-label" }
const _hoisted_18 = { class: "btn-text" }
const _hoisted_19 = { class: "col d-flex flex-row align-items-center justify-content-center" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  key: 1,
  class: "d-flex flex-row align-items-center"
}
const _hoisted_22 = {
  key: 0,
  class: "loader-25 margin-left-3"
}
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "pagination-wrapper mt-1" }
const _hoisted_25 = { class: "loader-div-40" }
const _hoisted_26 = ["src"]

import {
  computed,
  defineAsyncComponent,
  onMounted,
  onUnmounted,
  ref,
  watchEffect,
} from "vue";
import {
  ElButton,
  ElCard,
  ElDropdown,
  ElDropdownItem,
  ElDropdownMenu,
  ElInput,
  ElSwitch,
  ElTable,
  ElTableColumn,
  ElTag,
  ElDivider,
} from "element-plus";
import { cloneDeep } from "lodash-es";
import { TYPE } from "vue-toastification";
import { showAlert, showConfirm } from "@/core/popup";
import {
  cloneFlow,
  connectWebsocket,
  convertDate,
  deleteFlow,
  getElasticLogs,
  getFilteredFlowList,
  getLatestLogs,
  getLatestStartedLogs,
  inLineEditFlow,
  isRunning,
  startFlow,
} from "@/flow/services/flow.service";
import {
  getAllFlowLogByActivityId,
  buildActivityLogLines,
  getFlowLogZipById,
} from "@/dashboard/services/flow_log.service";
import { ASSETS_BASE_URL, DEFAULT_LOGO, getResolution } from "@/core/logo";
import i18n from "@/core/i18n/i18n";
import {
  hasPermission,
  updateMultiplePreference,
  updateSinglePreference,
} from "@/core/auth";
import { router } from "@/core/router";
import { getPreferenceValue } from "@/core/preferences/preferences";
import { useDebouncedSearch } from "@/core/composables/useDebouncedSearch";
import { useLatestRequestGuard } from "@/core/composables/useLatestRequestGuard";
import OneTegPagination from "@/common/components/OneTegPagination.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Flows',
  setup(__props) {

const { t } = i18n.global;
const flowsRequestGuard = useLatestRequestGuard();

const SimulateDialog = defineAsyncComponent(
  () => import("@/flow/components/SimulateDialog.vue")
);

const flowList = ref([]);
const loadingFlows = ref(false);
const loadingFlowEdit = ref(false);

const selectedBuffer = ref([]);
const outputBuffer = ref([]);

const simulateDialogVisible = ref(false);
const outputMap = ref<Map<any, any>>(new Map());

const selectedFlowId = ref();

const hoverId = ref("");
const flowName = ref("");
const processLogs = ref();
const flowValue = ref();
const activityId = ref();

const search = ref("");
const sortField = ref(
  getPreferenceValue("flowsSortField")
    ? getPreferenceValue("flowsSortField")
    : "createdAt"
);
const sortAscending = ref(
  getPreferenceValue("flowsSortOrder")
    ? getPreferenceValue("flowsSortOrder")
    : "ascending"
);

const tableRef = ref<InstanceType<typeof ElTable>>();

const charLimit = ref(200);
const clonedFlowCharLimit = ref(250);

const currentCharLimit = computed(() => {
  if (newObject.value && newObject.value.name) {
    return newObject.value.name.includes("CLONE")
      ? clonedFlowCharLimit.value
      : charLimit.value;
  }
  return charLimit.value;
});

const isNameNearLimit = computed(() => {
  if (newObject.value?.name?.includes("CLONE")) {
    return newObject.value?.name?.length > clonedFlowCharLimit.value;
  }
  return newObject.value?.name?.length > charLimit.value;
});

const isDescriptionNearLimit = computed(
  () => newObject.value?.description?.length > currentCharLimit.value
);

let client;

const statusClient = ref();

const editMode = ref(false);
const animate = ref(false);

const scrollInterval = ref();

const newObject = ref({
  name: undefined,
  description: undefined,
  id: undefined,
  active: undefined,
});

function cellMouseEnter(row, scope) {
  hoverId.value = row.id;
  const logoDiv = document.getElementById(`logo-div-${row.id}`);
  if (scope.no === 1 && logoDiv) {
    if (logoDiv.scrollLeft > 0) {
      scrollInterval.value = setInterval(() => {
        logoDiv.scrollTo(logoDiv.scrollLeft - 2, 0);
      }, 15);
    } else {
      scrollInterval.value = setInterval(() => {
        logoDiv.scrollTo(logoDiv.scrollLeft + 2, 0);
      }, 15);
    }
  }
}

function cellMouseLeave() {
  hoverId.value = "";
  if (scrollInterval.value) {
    clearInterval(scrollInterval.value);
  }
}

const perPageFlows = ref(
  getPreferenceValue("pageSize") ? getPreferenceValue("pageSize") : 10
);

const currentPageFlows = ref(1);

const numberOfFlows = ref(0);

function handleSizeChange(val) {
  perPageFlows.value = val;
  updateSinglePreference("pageSize", val);
  getFlows();
}

const { onSearchInput } = useDebouncedSearch(getFlows);

function sortChanged(sort) {
  sortField.value = sort.prop;
  sortAscending.value = sort.order;
  updateMultiplePreference({
    flowsSortField: sort.prop,
    flowsSortOrder: sort.order,
  });
  getFlows();
}

function openEditMode(row) {
  animate.value = false;
  if (
    newObject.value.id !== row.id &&
    hasPermission("FLOWS.LIST.INLINE.EDIT")
  ) {
    newObject.value = cloneDeep(row);
    editMode.value = true;
  }
}

async function goToEditPage(row) {
  if (
    hasPermission("FLOWS.LIST.EDIT") &&
    newObject.value.id !== row.id &&
    !loadingFlowEdit.value
  ) {
    loadingFlowEdit.value = true;

    try {
      const navigationFailure = await router.push(
        `/flows/edit/${row.id}/${row.version}`
      );

      if (navigationFailure) {
        loadingFlowEdit.value = false;
      }
    } catch (error) {
      loadingFlowEdit.value = false;
      showAlert(TYPE.ERROR, t("Flow.OpenFlowError"));
      console.error("flow edit navigation failed:", error);
    }
  } else if (newObject.value.id === row.id) {
    animate.value = true;
    setTimeout(() => {
      animate.value = false;
    }, 2200);
  }
}

async function goToCreatePage() {
  if (loadingFlowEdit.value) {
    return;
  }
  loadingFlowEdit.value = true;

  try {
    const navigationFailure = await router.push("/flows/create");

    if (navigationFailure) {
      loadingFlowEdit.value = false;
    }
  } catch (error) {
    loadingFlowEdit.value = false;
    showAlert(TYPE.ERROR, t("Flow.OpenFlowError"));
    console.error("flow create navigation failed:", error);
  }
}

function closeEditMode() {
  editMode.value = false;
  newObject.value = {
    id: undefined,
    active: undefined,
    name: undefined,
    description: undefined,
  };
}

function updatedConnectionSpecIdList(arr) {
  if (arr !== null && arr.length > 0) {
    // Remove null connectionSpecIdList of condition steps
    const filteredList = arr.filter((item) => item !== null);
    // Reverse the connectionSpecIdList list to display logos starting from the first step
    const reversedList =
      filteredList !== null && filteredList.length > 0
        ? filteredList.slice().reverse()
        : [];
    return removeDuplicates(reversedList);
  }
  return [];
}

function removeDuplicates(arr: []) {
  if (arr !== null && arr.length > 0) {
    return [...new Set(arr)];
  }
  return [];
}

async function changeActiveStatusFlow(flow) {
  if (hasPermission("FLOWS.LIST.INLINE.CHANGE_ACTIVE")) {
    const result = await lineEditFlow(flow);
    if (result) {
      if (!flow.active) {
        await getFlows();
        showAlert(TYPE.WARNING, "Flow is deactivated.");
        setTimeout(() => {
          showAlert(
            TYPE.INFO,
            "The schedule of the inactivated flow has been removed."
          );
        }, 1000);
      } else {
        await getFlows();
        showAlert(TYPE.SUCCESS, "Flow is activated.");
      }
    }
  }
}

async function editSelectedFlow() {
  if (
    editMode.value &&
    newObject.value.name &&
    hasPermission("FLOWS.LIST.INLINE.EDIT")
  ) {
    if (
      newObject?.value?.name?.length > currentCharLimit.value ||
      newObject?.value?.description?.length > currentCharLimit.value
    ) {
      showAlert(
        TYPE.ERROR,
        t("Common.CharacterLimitWarning", { limit: currentCharLimit.value })
      );
      return;
    }
    const result = await lineEditFlow(newObject.value);
    if (result) {
      editMode.value = false;
      newObject.value = {
        id: undefined,
        active: undefined,
        name: undefined,
        description: undefined,
      };
      await getFlows();
      showAlert(TYPE.SUCCESS, "Flow successfully saved.");
    }
  } else if (hasPermission("FLOWS.LIST.INLINE.EDIT")) {
    showAlert(TYPE.WARNING, "Please fill name.");
  }
}

async function lineEditFlow(flow) {
  let result = false;
  await inLineEditFlow(flow.id, flow).then(async (response) => {
    if (response) {
      result = true;
    }
  });
  return result;
}

async function cloneSelectedFlow(flow) {
  loadingFlows.value = true;
  await cloneFlow(flow.id, flow.name).then((response) => {
    if (response) {
      getFlows();
    }
    loadingFlows.value = false;
  });
}

onMounted(() => {
  getFlows();
});

onUnmounted(() => {
  if (statusClient.value) {
    statusClient.value.disconnect();
  }
  if (client) {
    client.disconnect();
  }
});

async function getFlows() {
  const requestToken = flowsRequestGuard.start();
  loadingFlows.value = true;
  const params = {
    pageNumber: currentPageFlows.value - 1,
    pageSize: perPageFlows.value,
    sortField: sortField.value,
    ascending: sortAscending.value === "ascending",
    search: search.value,
  };
  try {
    const page = await getFilteredFlowList(params);
    // OT-4928: discard a stale response superseded by a newer search/request.
    if (!flowsRequestGuard.isLatest(requestToken)) {
      return;
    }
    flowList.value = page.data;
    numberOfFlows.value = page.totalElements;
  } finally {
    // OT-4928: only the newest request owns the spinner — a superseded one must
    // not clear it, and a newest one that fails must not leave it stuck on.
    if (flowsRequestGuard.isLatest(requestToken)) {
      loadingFlows.value = false;
    }
  }
}

function startSelectedFlow(flow) {
  if (hasPermission("FLOWS.LIST.RUN")) {
    flow.loading = true;
    flowName.value = "";
    simulateDialogVisible.value = false;
    flowName.value = flow.name;
    outputBuffer.value = [];
    outputMap.value.clear();
    selectedFlowId.value = flow.id;
    flowValue.value = flow;
    startFlow(flow.id, flow.version)
      .then(() => {
        simulateDialogVisible.value = true;
        readFlowProcess(flow, true);
      })
      .catch(() => {
        showAlert(TYPE.ERROR, "An error occurred while starting the flow.");
      })
      .finally(() => {
        flow.loading = false;
      });
  }
}

function logRow(row) {
  if (row.includes("\n")) {
    outputBuffer.value.push(...row.split("\n"));
  } else {
    outputBuffer.value.push(row);
  }
}

async function elasticLogs(flow) {
  const logInfo = await getElasticLogs(flow.id, flow.version);
  if (!logInfo) {
    outputBuffer.value.splice(0);
    outputBuffer.value.push(
      "Process logs for this flow and version could not be found."
    );
    outputMap.value.set(flow.id, outputBuffer.value);
    return;
  }
  const response = await getAllFlowLogByActivityId(logInfo.id);
  activityId.value = logInfo.id;
  if (response) {
    // Renders step logs and flow-level error logs together, so an activity whose only payload is an
    // error (a run that failed or was skipped before any step ran) still shows its reason.
    const flowProcessLog = buildActivityLogLines(
      response.flowLogDto.stepLogs,
      response.flowLogDto.errorLogs
    );
    outputBuffer.value.splice(0);
    flowProcessLog.forEach(logRow);
  }
  outputMap.value.set(flow.id, outputBuffer.value);
  processLogs.value = outputBuffer;
}

async function readFlowProcess(flow, init) {
  if (outputMap.value.has(flow.id)) {
    outputBuffer.value = outputMap.value.get(flow.id);
  } else if (!init) {
    const latest = await getLatestLogs(flow.id);
    if (latest) {
      outputBuffer.value.splice(0);
      const logRowArray = latest.processLog.log.split("\n");
      logRowArray.forEach(logRow);
    } else {
      outputBuffer.value = [];
    }
  } else {
    outputBuffer.value = [];
  }

  outputMap.value.set(flow.id, outputBuffer.value);
  if (client) {
    client.disconnect();
    client = undefined;
  }
  connectWebsocket().then((stompClient) => {
    stompClient.debug = (f) => f;
    client = stompClient;
    stompClient.connect({}, () => {
      stompClient.subscribe(`/flow/${flow.id}/process`, (val) => {
        outputBuffer.value.push(val.body);
      });
    });
  });
  processLogs.value = outputBuffer.value;
}

async function showOutput(flow) {
  flowValue.value = flow;
  simulateDialogVisible.value = false;
  const flowStatus = isRunning(flow.flowStatusType);
  flowName.value = "";
  if (flowStatus) {
    outputMap.value.clear();
    outputBuffer.value = [];
    await readFlowProcess(flow, false);
  } else {
    await elasticLogs(flow);
  }
  selectedFlowId.value = flow.id;
  simulateDialogVisible.value = true;
  flowName.value = flow.name;
}

async function deleteSelectedFlow(flow) {
  if (hasPermission("FLOWS.LIST.REMOVE")) {
    const isConfirmed = await showConfirm(
      "warning",
      t("Flow.DeleteFlow"),
      t("Flow.DeleteFlowConfirmation", { name: flow.name })
    );
    if (isConfirmed) {
      flow.loading = true;
      await deleteFlow(flow.id, flow.version, flow.name);
      flow.loading = false;

      await getFlows();
    }
  }
}

watchEffect(() => {
  selectedBuffer.value = outputMap.value.get(selectedFlowId.value);
});

function closeSimulateDialog() {
  simulateDialogVisible.value = false;
}

function isDisabled(id) {
  return outputMap.value.has(id);
}

async function downloadLogsAsText(flow) {
  const latestStartedLog = await getLatestStartedLogs(flow.id);
  activityId.value = latestStartedLog.id;
  if (!activityId.value) {
    showAlert(TYPE.WARNING, t("Flow.ProcessLogDownloadError"));
    return;
  }
  const response = await getFlowLogZipById(activityId.value);
  const blob = new Blob([response], { type: "application/zip" });
  const link = document.createElement("a");
  link.setAttribute("download", `${flow.name}-flow-logs.zip`);
  link.href = URL.createObjectURL(blob);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(ElCard), {
        id: "flows-card",
        class: "card border-0 oneTeg-card oneTeg-card-body"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ElTable), {
            data: flowList.value,
            ref_key: "tableRef",
            ref: tableRef,
            "row-class-name": 
          _unref(hasPermission)('FLOWS.LIST.EDIT')
            ? 'oneTeg-table-row-permission'
            : 'oneTeg-table-row-no-permission'
        ,
            "empty-text": loadingFlows.value ? ' ' : 'No Data',
            onRowClick: goToEditPage,
            onCellMouseEnter: cellMouseEnter,
            onCellMouseLeave: cellMouseLeave,
            onSortChange: sortChanged,
            "default-sort": { prop: sortField.value, order: sortAscending.value },
            height: "97%",
            class: "oneTeg-table"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ElTableColumn), {
                label: _unref(t)('Flow.FlowName'),
                prop: "name",
                sortable: "custom",
                width: "400px"
              }, {
                default: _withCtx((scope) => [
                  (scope.row.id === newObject.value.id && editMode.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        id: 'inline-edit-' + scope.$index
                      }, [
                        _createVNode(_unref(ElInput), {
                          placeholder: _unref(t)('Common.Name'),
                          id: 'name-input-' + scope.$index,
                          size: "mini",
                          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                          modelValue: newObject.value.name,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newObject.value.name) = $event))
                        }, null, 8, ["placeholder", "id", "modelValue"]),
                        (isNameNearLimit.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                              _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)("Common.CharacterLimitWarning", { limit: currentCharLimit.value })), 1)
                            ]))
                          : _createCommentVNode("", true),
                        _hoisted_5,
                        _createVNode(_unref(ElInput), {
                          placeholder: _unref(t)('Common.Description'),
                          size: "mini",
                          id: 'description-input-' + scope.$index,
                          class: "oneteg-mt-3",
                          onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
                          modelValue: newObject.value.description,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newObject.value.description) = $event))
                        }, null, 8, ["placeholder", "id", "modelValue"]),
                        (isDescriptionNearLimit.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                              _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)("Common.CharacterLimitWarning", { limit: currentCharLimit.value })), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_2))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        id: 'name-' + scope.$index,
                        class: "break-word"
                      }, [
                        _createElementVNode("a", {
                          id: 'name-label-' + scope.$index,
                          class: "flow-name"
                        }, _toDisplayString(scope.row.name), 9, _hoisted_9),
                        (
                  _unref(hasPermission)('FLOWS.LIST.INLINE.EDIT') &&
                  scope.row.id === hoverId.value
                )
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: "pencil-span",
                              id: 'inline-edit-pencil-' + scope.$index,
                              onClick: _withModifiers(($event: any) => (openEditMode(scope.row)), ["stop"])
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: "pencil-alt" })
                            ], 8, _hoisted_10))
                          : _createCommentVNode("", true),
                        _hoisted_11,
                        _createTextVNode(" " + _toDisplayString(scope.row.description) + " ", 1),
                        _createElementVNode("div", null, _toDisplayString("v" + scope.row.version), 1)
                      ], 8, _hoisted_8))
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_unref(ElTableColumn), {
                label: _unref(t)('Common.Connections'),
                width: "auto"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: "d-flex flex-row logo-strip",
                    id: 'logo-div-' + scope.row.id
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(updatedConnectionSpecIdList(
                  scope.row.connectionSpecIdList
                ), (specId, index) => {
                      return (_openBlock(), _createElementBlock("img", {
                        class: "logo-l margin-right-10",
                        id: 'icon-' + scope.$index + '-' + index,
                        key: index,
                        src: `${_unref(ASSETS_BASE_URL)}/${specId}${_unref(getResolution)(false)}.png`,
                        alt: specId
                      }, null, 8, _hoisted_13))
                    }), 128))
                  ], 8, _hoisted_12)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_unref(ElTableColumn), {
                label: _unref(t)('Flow.Scheduled'),
                prop: "scheduledType",
                width: "180px"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_unref(ElTag), {
                    type: 
                scope.row.scheduleType === 'SCHEDULED'
                  ? ''
                  : scope.row.scheduleType === 'WEBHOOK'
                  ? 'success'
                  : 'info'
              
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(scope.row.scheduleType === "SCHEDULED"
                  ? _unref(convertDate)(scope.row.nextFireTime)
                  : scope.row.scheduleType), 1)
                    ]),
                    _: 2
                  }, 1032, ["type"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_unref(ElTableColumn), {
                label: _unref(t)('Common.Active'),
                prop: "active",
                width: "130px"
              }, {
                default: _withCtx((scope) => [
                  (editMode.value && scope.row.id === newObject.value.id)
                    ? (_openBlock(), _createBlock(_unref(ElSwitch), {
                        key: 0,
                        id: 'active-' + scope.$index,
                        "active-color": "#5022a6",
                        modelValue: newObject.value.active,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((newObject.value.active) = $event)),
                        onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                      }, null, 8, ["id", "modelValue"]))
                    : (_openBlock(), _createBlock(_unref(ElSwitch), {
                        key: 1,
                        id: 'active-' + scope.$index,
                        modelValue: scope.row.active,
                        "onUpdate:modelValue": ($event: any) => ((scope.row.active) = $event),
                        "active-color": "#5022a6",
                        onClick: _withModifiers(($event: any) => (changeActiveStatusFlow(scope.row)), ["stop"]),
                        disabled: !_unref(hasPermission)('FLOWS.LIST.INLINE.CHANGE_ACTIVE')
                      }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "onClick", "disabled"]))
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_unref(ElTableColumn), { width: "300px" }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_unref(ElInput), {
                      modelValue: search.value,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((search).value = $event)),
                      size: "mini",
                      id: "search-input",
                      class: "oneTeg-search-input max-w-170",
                      onInput: _unref(onSearchInput),
                      placeholder: _unref(t)('Common.TypeToSearch')
                    }, null, 8, ["modelValue", "onInput", "placeholder"]),
                    _createVNode(_unref(ElDivider), {
                      direction: "vertical",
                      class: "v-divider-stretch",
                      "aria-hidden": "true"
                    }),
                    _createElementVNode("div", _hoisted_15, [
                      (_unref(hasPermission)('FLOWS.LIST.CREATE'))
                        ? (_openBlock(), _createBlock(_unref(ElButton), {
                            key: 0,
                            id: "create-button",
                            class: "no-border btn-oneTeg2-table-create btn-labeled",
                            size: "mini",
                            type: "primary",
                            onClick: _withModifiers(goToCreatePage, ["stop"])
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_16, [
                                _createElementVNode("span", _hoisted_17, [
                                  _createVNode(_component_font_awesome_icon, { icon: "plus" })
                                ]),
                                _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(t)("Flow.CreateFlow")), 1)
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_19, [
                    (
                  editMode.value &&
                  scope.row.id === newObject.value.id &&
                  _unref(hasPermission)('FLOWS.LIST.INLINE.EDIT')
                )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _createElementVNode("div", {
                            class: _normalizeClass({ animateBtn: animate.value })
                          }, [
                            _createVNode(_unref(ElButton), {
                              class: "btn-oneTeg max-w-42-5",
                              id: 'inline-edit-save-' + scope.$index,
                              size: "mini",
                              type: "primary",
                              onClick: _withModifiers(editSelectedFlow, ["stop"])
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, { icon: "check" })
                              ]),
                              _: 2
                            }, 1032, ["id"]),
                            _createVNode(_unref(ElButton), {
                              class: "btn-oneTeg margin-left-3",
                              id: 'inline-edit-back-' + scope.$index,
                              size: "mini",
                              type: "primary",
                              onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (closeEditMode()), ["stop"]))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, { icon: "times" })
                              ]),
                              _: 2
                            }, 1032, ["id"])
                          ], 2)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _createVNode(_unref(ElDropdown), null, {
                            dropdown: _withCtx(() => [
                              _createVNode(_unref(ElDropdownMenu), null, {
                                default: _withCtx(() => [
                                  (_unref(hasPermission)('FLOWS.LIST.EDIT'))
                                    ? (_openBlock(), _createBlock(_unref(ElDropdownItem), {
                                        key: 0,
                                        id: 'edit-button-' + scope.$index,
                                        onClick: _withModifiers(($event: any) => (goToEditPage(scope.row)), ["stop"])
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_unref(t)("Common.Edit")), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["id", "onClick"]))
                                    : _createCommentVNode("", true),
                                  (_unref(hasPermission)('FLOWS.LIST.EXPORT'))
                                    ? (_openBlock(), _createBlock(_unref(ElDropdownItem), {
                                        key: 1,
                                        id: 'export-button-' + scope.$index,
                                        onClick: _withModifiers(($event: any) => (
                          _ctx.$router.push(
                            `/flows/export/${scope.row.id}/${scope.row.version}`
                          )
                        ), ["stop"])
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_unref(t)("Flow.Export")), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["id", "onClick"]))
                                    : _createCommentVNode("", true),
                                  (
                          (_unref(hasPermission)('FLOWS.LIST.EDIT') ||
                            _unref(hasPermission)('FLOWS.LIST.CREATE')) &&
                          !scope.row.name.includes('CLONE')
                        )
                                    ? (_openBlock(), _createBlock(_unref(ElDropdownItem), {
                                        key: 2,
                                        id: 'clone-button-' + scope.$index,
                                        onClick: _withModifiers(($event: any) => (cloneSelectedFlow(scope.row)), ["stop"])
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_unref(t)("Flow.Clone")), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["id", "onClick"]))
                                    : _createCommentVNode("", true),
                                  (_unref(hasPermission)('FLOWS.LIST.RUN'))
                                    ? (_openBlock(), _createBlock(_unref(ElDropdownItem), {
                                        key: 3,
                                        id: 'run-button-' + scope.$index,
                                        disabled: 
                          _unref(isRunning)(scope.row.flowStatusType) ||
                          !scope.row.active
                        ,
                                        onClick: _withModifiers(($event: any) => (startSelectedFlow(scope.row)), ["stop"])
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_unref(t)("Flow.Run")), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["id", "disabled", "onClick"]))
                                    : _createCommentVNode("", true),
                                  (_unref(hasPermission)('FLOWS.LIST.RUN'))
                                    ? (_openBlock(), _createBlock(_unref(ElDropdownItem), {
                                        key: 4,
                                        id: 'process-logs-button-' + scope.$index,
                                        onClick: _withModifiers(($event: any) => (showOutput(scope.row)), ["stop"]),
                                        disabled: 
                          !isDisabled(scope.row.id) && !scope.row.active
                        
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_unref(t)("Flow.ProcessLogs")), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["id", "onClick", "disabled"]))
                                    : _createCommentVNode("", true),
                                  (_unref(hasPermission)('FLOWS.LIST.REMOVE'))
                                    ? (_openBlock(), _createBlock(_unref(ElDropdownItem), {
                                        key: 5,
                                        id: 'remove-button-' + scope.$index,
                                        onClick: _withModifiers(($event: any) => (deleteSelectedFlow(scope.row)), ["stop"]),
                                        disabled: _unref(isRunning)(scope.row.flowStatusType)
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_unref(t)("Common.Delete")), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["id", "onClick", "disabled"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_unref(ElButton), {
                                class: "no-border btn-oneTeg show-on-row-hover",
                                size: "mini",
                                id: 'gear-' + scope.$index,
                                type: "primary",
                                onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_font_awesome_icon, { icon: "cog" })
                                ]),
                                _: 2
                              }, 1032, ["id"])
                            ]),
                            _: 2
                          }, 1024),
                          (scope.row.loading)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                _createElementVNode("img", {
                                  src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
                                  alt: "Loading...",
                                  class: "loader-logo-25"
                                }, null, 8, _hoisted_23)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data", "row-class-name", "empty-text", "default-sort"]),
          _createElementVNode("div", _hoisted_24, [
            _createVNode(OneTegPagination, {
              "page-sizes": [10, 25, 50, 100],
              "page-size": perPageFlows.value,
              "onUpdate:pageSize": _cache[9] || (_cache[9] = ($event: any) => ((perPageFlows).value = $event)),
              total: numberOfFlows.value,
              "current-page": currentPageFlows.value,
              "onUpdate:currentPage": _cache[10] || (_cache[10] = ($event: any) => ((currentPageFlows).value = $event)),
              background: true,
              small: true,
              onSizeChange: handleSizeChange,
              onCurrentChange: getFlows,
              layout: 'total, sizes, prev, pager, next'
            }, null, 8, ["page-size", "total", "current-page"])
          ])
        ]),
        _: 1
      }),
      _withDirectives(_createElementVNode("div", _hoisted_25, [
        _createElementVNode("img", {
          src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
          alt: "Loading...",
          class: "loader-logo-40"
        }, null, 8, _hoisted_26)
      ], 512), [
        [_vShow, loadingFlows.value || loadingFlowEdit.value]
      ])
    ]),
    (simulateDialogVisible.value)
      ? (_openBlock(), _createBlock(_unref(SimulateDialog), {
          key: 0,
          dialog: simulateDialogVisible.value,
          selectedBuffer: selectedBuffer.value,
          flowName: flowName.value,
          moved: false,
          stoppable: false,
          onClose: closeSimulateDialog,
          onDownloadLogsAsText: _cache[11] || (_cache[11] = ($event: any) => (downloadLogsAsText(flowValue.value)))
        }, null, 8, ["dialog", "selectedBuffer", "flowName"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})